
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chi-tiet-van-ban/[...slug]",
      function () {
        return require("private-next-pages/chi-tiet-van-ban/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chi-tiet-van-ban/[...slug]"])
      });
    }
  